import api from '@/helpers/api'
import axios from '@/helpers/axios'
import Vue from "vue";

function showNotifications(notifications, commit) {
    var BreakException = {};

    try {
        notifications.filter( notification => { return ! notification.is_read && notification.is_popup }).forEach(notification => {
            if(notification.type === 'marketing') {
                commit('SET_READ', notification.id)
            }
            Vue.swal({
                heightAuto: false,
                title: notification.title,
                customClass: 'smis-notifications',
                showConfirmButton: false,
                showCloseButton: true,
                html: notification.message,
            }).then(() => {
                commit('SET_READ', notification.id)
                notification.is_read = true
                showNotifications(notifications, commit)
            })
            throw BreakException;
        })
    } catch (e) {
        if (e !== BreakException) throw e;
    }

}

export default {
    namespaced: true,

    state: {
        notifications: [],
    },

    getters: {
        notifications: state => state.notifications,
    },

    mutations: {
        UPDATE_NOTIFICATIONS(state, item) {
            state.notifications[item.id] = item.value;
        },

        INITIALIZE_NOTIFICATIONS(state, commit) {
            axios.get(api.API_ENDPOINTS.notifications)
                .then( response => {
                    state.notifications = response.data['notifications'];
                    showNotifications(state.notifications, commit)
                })
        },

        SET_ALLREAD(state) {
            state.notifications.forEach(notification => {
                notification.is_read = true
            })
            axios.post(api.API_ENDPOINTS.notifications + '/mark-all-read')
        },

        SET_READ(state, id) {
            axios.post(api.API_ENDPOINTS.notifications + '/mark-read', {id: id})
        }
    },

    actions: {
        updateNotifications({ commit }, item) {
            commit('UPDATE_NOTIFICATIONS', item)
        },

        initializeNotifications({commit}) {
            commit('INITIALIZE_NOTIFICATIONS', commit)
        },

        setAllRead({commit}) {
            commit('SET_ALLREAD')
        },

        setRead({commit}, id) {
            commit('SET_READ', id)
        }
    },
}
